export enum MaximumLeveragePointPropertyEnum {
  AMOUNT = 'amount',
  THRESHOLD_TYPE = 'thresholdType',
}
